import { consultationConstants } from '../_constants';


export const consultationActions = {
    setCallFinished
};

function setCallFinished(data) {
    return dispatch => {
        dispatch(success(data));
    };

    function success(data) { return { type: consultationConstants.SET_CALL_FINISHED, data } }
}
